var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('dashboard-core-app-bar'),_c('dashboard-core-drawer'),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('route-breadcrumb'),_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }